import fs from 'node:fs'
import path from 'node:path'
import { CONFIG_FILE_NAME } from '@cli-constants/paths.js'
import { DEFAULT_ADMIN_NAMESPACE } from '@cli-constants/scaffolding.js'
import { validateAdminNamespace } from '@next-adapter/config/namespace/validate-admin-namespace.js'
import { readExistingConfigNamespace } from './read-existing-config-namespace.js'

export async function resolveForceInitNamespaces(
  cwd: string,
  targetNamespace: string
): Promise<string[]> {
  const namespaces = new Set<string>([validateAdminNamespace(targetNamespace)])
  const hasConfig = fs.existsSync(path.resolve(cwd, CONFIG_FILE_NAME))
  const existingNamespace = await readExistingConfigNamespace(cwd)

  if (existingNamespace) {
    namespaces.add(existingNamespace)
  } else if (hasConfig) {
    namespaces.add(DEFAULT_ADMIN_NAMESPACE)
  }

  return [...namespaces]
}
